<template>
  <button :class="`common_default_button ${ isOther ? 'other' : '' } ${size}`" @click="clickHandle">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'ButtonDefault',

  props: {
    isOther: { // 另一种样式
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: ''
    }
  },

  methods: {
    clickHandle () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.common_default_button {
  height: 22px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: $btn_color_default;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid $btn_color_default;
  border-radius: 4px;
  outline: none;

  &:hover { color: #fff; background-color: $btn_color_default; }
  &:active { color: #fff; background-color: $btn_color_active; }

  &.mini { height: 28px; font-size: 12px; }

  &.middle { height: 31px; font-size: 14px; }

  &.other {
    color: #fff;
    background-color: $btn_color_default;

    &:hover { background-color: $btn_color_weak; }
    &:active { background-color: $btn_color_active; }
  }
}
</style>
